module.exports = __webpack_public_path__ + "static/img/microStation.743515e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/microStation.png
// module id = FxvI
// module chunks = 208